import React from 'react';
import { Container } from 'semantic-ui-react';
import { toSnakeCase } from '../helpers/common';

const OneColumnWysiwyg = (props) => {
  const {
    anchorTagLinkText,
    heading,
    textColor,
    text,
    type = '',
    className = '',
    feature = false,
    fullWidth = false,
  } = props;

  return (
    <section
      className={`one-column-wysiwyg ${className} ${fullWidth ? 'one-column-wydsiwyg--full-width' : ''}`}
      id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
    >
      <Container>
        <div className="grid-wrapper">
          {feature ? (
            <div className="one-column-wysiwyg__feature-background"></div>
          ) : null}
          <div
            className={`${
              'wysiwyg ' + type
            } ${'one-column-wysiwyg__container'}`}
          >
            {heading && (
              <h2 className="wysiwyg__heading heading-one">{heading}</h2>
            )}
            <div
              className={`${textColor && textColor}`}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default OneColumnWysiwyg;
